// SEE: https://atlaskit.atlassian.com/packages/design-system/select/example/select-in-modal-dialog
export const EXTRA_SELECT_PROPS = {
	menuPortalTarget: document.body,
	styles: { menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) },
};

// NOTE: Now on prefer to use this and replace the above one. See: https://ifountain.atlassian.net/browse/TARDIS-9312
// SEE: https://atlaskit.atlassian.com/packages/design-system/select/example/select-in-modal-dialog
export const GET_EXTRA_SELECT_PROPS = () => ({
	menuPortalTarget: document.body,
	styles: { menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) },
});

export const COMMON_SPOTLIGHT_NAMES = {
	firstListRotationItem: 'eoc-schedule_first_list_schedule_item',
	editRotationTimings: 'eoc-schedule-edit_rotation_timings',
	editRotationForm: 'eoc-schedule_edit_rotation_rotation',
	editModeSchedule: 'eoc-schedule-edit_mode_schedule',
};

export const COMMON_SPOTLIGHT_TOURS = {
	rotationEdit: 'eoc-schedule-rotation-edit',
	rotationList: 'eoc-schedule-rotation-list',
};

/*
 * Times - ["00:00", "00:30", ..., "23:00", "23:30"]
 */
export const DEFAULT_TIMES = Array.from({ length: 24 }, (_, i) => i).flatMap((time) => {
	return [`${time}:00`, `${time}:30`].map((t) => t.padStart(5, '0'));
});

export enum PeriodType {
	Schedule = 'schedule',
	Override = 'override',
	Forwarding = 'forwarding',
}

export enum ShiftFrequency {
	Daily = 'daily',
	Weekly = 'weekly',
	Custom = 'custom',
}

export enum TimingType {
	Everday = 'everyday',
	Customday = 'customday',
}

export enum RotationType {
	DAILY = 'daily',
	WEEKLY = 'weekly',
	HOURLY = 'hourly',
	INVALID = 'invalid',
}

// This is used in BE requests, do not use to change behaviour at runtime
export enum NavigationMode {
	Calendar = 'calendar',
	Timeline = 'timeline',
}

// This is used in BE requests, do not use to change behaviour at runtime
export enum NavigationPeriodId {
	OneDay = 1,
	OneWeek,
	TwoWeeks,
	OneMonth,
}

export enum LayerType {
	Base = 'defaultLayers',
	Override = 'overrideLayers',
	Forwarding = 'forwardingLayers',
	Final = 'finalLayers',
}

// Confirm, Customize Override, Edit, Revert are not actions! They have side effects
// In success of that side effect call action: 'Close', otherwise do nothing!
export enum ShiftAction {
	AddOverride = 'add-override',
	Cancel = 'cancel',
}

export enum ShiftStatus {
	Default = 'default',
	Multi = 'multi',
	MultiQuickOverride = 'multi-quick-override',
	Single = 'single',
	SingleViewOnly = 'single-view-only',
	SingleOverriden = 'single-overriden',
	SingleQuickOverride = 'single-quick-override',
}
